import script from "./LandingResourceAvailableRewards.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingResourceAvailableRewards.vue?vue&type=script&setup=true&lang=js"

import "./LandingResourceAvailableRewards.vue?vue&type=style&index=0&id=36ccbe5d&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ccbe5d"]])

export default __exports__